/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function urlWithParams(urlString, params = {}) {
    let searchParams = '';
    Object.keys(params).forEach((key) => {
        let sep = '';
        if (searchParams !== '') {
            sep = '&';
        }
        const val = params[key];
        if (val || val === 0) {
            if (Array.isArray(val)) {
                val.forEach((v) => {
                    if (searchParams !== '') {
                        sep = '&';
                    }
                    searchParams = `${searchParams + sep + key}=${encodeURIComponent(v)}`;
                });
            } else {
                searchParams = `${searchParams + sep + key}=${encodeURIComponent(val)}`;
            }
        }
    });
    let ret = urlString;
    if (searchParams) {
        ret = `${ret}?${searchParams}`;
    }
    return ret;
}
